import { Box, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ROUTE_PATHS } from "../routes";
import { BUTTON_COLOR, BUTTON_VARIANT } from "../types/coreButtonTypes";
import typography from "../theme/typography";
import palette from "../theme/palette";
import CoreButtons from "../components/core-components/button/CoreButtons";

export default function NotFoundPage() {
	const navigate = useNavigate();

	return (
		<Box sx={{ maxWidth: 500, width: "100%", mx: "auto", textAlign: "center", mt: 10 }}>
			<Stack spacing={2} sx={{ alignItems: "center" }}>
				<Typography sx={{ textAlign: "center", fontFamily: typography.fontSecondary,
						fontSize: 38,
						fontWeight: 600,
						color: palette.secondary.main, }}>
					Page not found
				</Typography>
				<Typography variant="body1" sx={{ color: palette.grey[700], textAlign: "center" }}>
					The page you are looking for does not exist or has been moved.
				</Typography>
				<Box sx={{ pt: 2 }}>
					<CoreButtons
						buttonText="Go to home"
						variant={BUTTON_VARIANT.CONTAINED}
						color={BUTTON_COLOR.PRIMARY}
						coreBtnPill
						onclick={() => navigate(ROUTE_PATHS.DASHBOARD)}
					/>
				</Box>
			</Stack>
		</Box>
	);
}
